import QuestionSVG from "@design-system/ui-icons/vanilla/Question"
import { createIcon } from "../createIcon"

export const QuestionIcon = createIcon(QuestionSVG)
